import {
  INewUser,
  PlatformContextType
} from "@wingspanhq/users/dist/lib/interfaces/newUser";

export const selectorHasPayeeContextUser = (user: INewUser) =>
  (user.contexts || []).some(
    context => context.type === PlatformContextType.Payee
  );
